import { createAction, props } from '@ngrx/store';
import { ILegalEntityTypesResponse } from '../models/legal-entity-types.model';

export const loadLegalEntityTypes = createAction('[LegalEntityType] Load LegalEntityTypes');

export const loadLegalEntityTypesSuccess = createAction(
  '[LegalEntityType] Load LegalEntityTypes Success',
  props<{ response: ILegalEntityTypesResponse[] }>()
);

export const loadLegalEntityTypesFailure = createAction('[LegalEntityType] Load LegalEntityTypes Failure', props<{ error: Error | any }>());
